module.exports = __webpack_public_path__ + "static/3-0d4daf5e235f8816504c85dbee3b31d0.jpg";